if (!customElements.get('sub-category-carousel')) {
  customElements.define('sub-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-sub-category-slider]');
      this.previousButton = this.querySelector('[data-category-previous]');
      this.nextButton = this.querySelector('[data-category-next]');
      if (!this.slider || !this.previousButton || !this.nextButton) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previousButton.addEventListener('click', () => this.move(-1), options);
      this.nextButton.addEventListener('click', () => this.move(1), options);
      this.slider.addEventListener('scroll', () => this.updateButtons(), { ...options, passive: true });
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.sub-category-pills__item');
        if (!item) return;
        const itemRect = item.getBoundingClientRect();
        const sliderRect = this.slider.getBoundingClientRect();
        if (itemRect.left < sliderRect.left || itemRect.right > sliderRect.right) {
          const offset = getComputedStyle(this.slider).direction === 'rtl'
            ? itemRect.right - sliderRect.right
            : itemRect.left - sliderRect.left;
          this.slider.scrollBy({ left: offset, behavior: 'instant' });
        }
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.slider);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }

    updateButtons() {
      const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
      const position = Math.abs(this.slider.scrollLeft);
      const isRtl = getComputedStyle(this.slider).direction === 'rtl';
      this.previousButton.disabled = maxScroll <= 2 || (isRtl ? position >= maxScroll - 2 : position <= 2);
      this.nextButton.disabled = maxScroll <= 2 || (isRtl ? position <= 2 : position >= maxScroll - 2);
    }

    move(direction) {
      const item = this.slider.querySelector('.sub-category-pills__item');
      if (!item) return;
      const distance = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.slider).columnGap);
      this.slider.scrollBy({
        left: direction * distance,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
  });
}
